import { c as _taggedTemplateLiteralLoose } from './chunk-eb25cfa0.js';
import { theme } from 'styled-tools';
import 'styled-components';
import styled from './styled.js';
import 'reuse';
import use from './use.js';
import 'react';
import { bool as bool$1 } from 'prop-types';
import './chunk-afcdbe83.js';
import { c as bool } from './chunk-1128464e.js';
import Box from './Box.js';
import '@emotion/is-prop-valid';

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  &&& {\n    ", ";\n  }\n\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var directions = ["row", "column", "rowReverse", "columnReverse"];
var Flex = styled(Box)(_templateObject(), bool("flex-direction", directions), theme("Flex")); // @ts-ignore

Flex.propTypes = {
  row: bool$1,
  column: bool$1,
  rowReverse: bool$1,
  columnReverse: bool$1
};
var Flex$1 = use(Flex, "div");

export default Flex$1;
